import React from 'react';

function SkeletonCard() {
  return (
    <div className="flex flex-col border border-black/20 rounded-[0.25rem] bg-white animate-pulse">
      <div className="px-[2.375rem] pt-[2.375rem] flex-shrink-0">
        <div className="w-full aspect-[409/249] bg-black/[0.08] rounded-[0.125rem]" />
      </div>
      <div className="flex flex-col gap-[3.375rem] px-[4.375rem] pt-[3.375rem] pb-[4.375rem]">
        <div className="flex flex-col gap-[1.75rem]">
          <div className="flex flex-col gap-[1rem]">
            <div className="h-[2rem] w-[12rem] bg-black/[0.08] rounded-[0.125rem]" />
            <div className="h-[3.6rem] w-full bg-black/[0.1] rounded-[0.125rem]" />
          </div>
          <div className="flex flex-col gap-[0.5rem]">
            <div className="h-[2rem] w-full bg-black/[0.08] rounded-[0.125rem]" />
            <div className="h-[2rem] w-full bg-black/[0.08] rounded-[0.125rem]" />
            <div className="h-[2rem] w-4/5 bg-black/[0.08] rounded-[0.125rem]" />
          </div>
        </div>
        <div className="h-[2rem] w-[10rem] bg-black/[0.08] rounded-[0.125rem]" />
      </div>
    </div>
  );
}

export default function ArticleGridSkeleton() {
  return (
    <section className="w-full flex flex-col items-center pb-[14rem]">
      <div className="mx-auto w-[min(176.375rem,calc(100%-8rem))] flex items-center justify-between gap-[4rem] mb-[6rem]">
        <div className="flex items-center gap-[1.25rem]">
          {[...Array(4)].map((_, i) => (
            <div
              key={i}
              className="h-[6.875rem] w-[10rem] bg-black/[0.06] rounded-[0.25rem] animate-pulse"
            />
          ))}
        </div>
        <div className="h-[6.875rem] w-[44rem] bg-black/[0.05] rounded-[0.25rem] animate-pulse" />
      </div>
      <div className="mx-auto w-[min(176.375rem,calc(100%-8rem))] grid grid-cols-3 gap-[4rem]">
        {[...Array(9)].map((_, i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
    </section>
  );
}
